// AdminSeed AI tools — RETIRED (owner, 2026-10-12, Stage 2 of the Gemini
// migration). Kept in the source for possible future use, NOT deleted.
//
// - AI supplier review ("Run AI snapshot"): judged not worth its value. Manual
//   review (approve / needs info / reject) is untouched and was never AI-gated.
// - Seed command: an AI prompt turned into writes against PRODUCTION —
//   `open` requests under the admin's id (which the open pool would route to
//   every operational supplier), active products, and a "close old requests"
//   action aimed at the OLDEST open requests, which are real traders'.
//
// Both entry points in AdminSeed.jsx return before any network or database
// call while these are false, and their buttons are not rendered. Turning one
// back on is a product decision, not a flag flip: the old code still calls
// Ai-proxy, which refuses it, so reviving it means a maabar-ai task with
// server-side admin authorization and rate limits first.
export const ADMIN_SEED_AI_REVIEW_ENABLED = false;
export const ADMIN_SEED_COMMAND_ENABLED = false;

// Both admin roles. The page used to test role === 'admin' only, so the owner
// (super_admin) was redirected away from it.
export const isAdminSeedRole = (role) => ['admin', 'super_admin'].includes(String(role || '').toLowerCase());
